import React from 'react'; // eslint-disable-line
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const PreviewModuleSideMenuItem = (props) => {
    return (

        <div id="discover" className={`menu-item tile ${props.active ? 'active' : ''}`}>
            <div className="iconic">
                <FontAwesomeIcon
                    color={props.active ? props.actionColor : props.secondaryText}
                    icon={['fal', props.menuItem.icon]}
                />
            </div>
            <h5 style={{ color: `${props.active ? props.actionColor : props.secondaryText}` }}>{props.menuItem.title}</h5>
        </div>
    );
};

export default PreviewModuleSideMenuItem;
